package pl.mothdigital.neuronowi.common.model

/**
 * Represents an image resource with optional aspect ratio for CLS prevention.
 *
 * @param src Image source path
 * @param description Alt text for accessibility
 * @param aspectRatio Optional CSS aspect-ratio value (e.g., "3/2", "16/9", "1/1")
 */
data class ImageResource(
    val src: String,
    val description: String,
    val aspectRatio: String? = null
)
